import { Spacer } from './perfect-spacer.styled';

export const PerfectSpacer = ({
  width,
  height,
}: PerfectSpacerProps): JSX.Element => {
  return <Spacer $width={ width } $height={ height } />;
};
